import React, { useState } from "react";
import { API_ROOT } from "../../constants";
import { ImgIcon } from "../../assets";
import { facebook, google } from "../../assets/icons";
import EmailLogin from "./EmailLogin";
import EmailSignup from "./EmailSignup";
import { useSelector } from "react-redux";
import { getAffiliate } from "../../helpers";
import ResetPasswordRequest from "./ResetPasswordRequest";
import ResetPassword from "./ResetPassword";

export const SOCIAL = "SOCIAL";
export const EMAIL_LOGIN = "EMAIL_LOGIN";
export const EMAIL_SIGNUP = "EMAIL_SIGNUP";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD = "RESET_PASSWORD";

export default function Login() {

	const {
		forEmailConfirmation,
		resetPassword,
		code,
		email
	} = useSelector(state => state.session.query);

	const [mode, setMode] = useState((() => {
		if (forEmailConfirmation === "true") {
			return EMAIL_LOGIN;
		} else if (resetPassword === "true" && code && email) {
			return RESET_PASSWORD;
		} else {
			return SOCIAL;
		}
	}));

	function onRequestFormChange(form) {
		setMode(form);
	}

	return <div className="login">
		<SocialButton provider="facebook" />
		<br />
		<SocialButton provider="google" />
		<div className="emailLogin">
			<hr />
			{![EMAIL_SIGNUP, EMAIL_LOGIN, RESET_PASSWORD_REQUEST, RESET_PASSWORD].includes(mode) && (
				<div
					className="socialButton socialButton-email brand-bg"
					onClick={e => {
						setMode(EMAIL_LOGIN);
					}}
				>
					<ImgIcon src={email} size={25} className="invert" />
					<span>Use email instead</span>
				</div>
			)}

			{/* Logging in manually */}
			{mode === EMAIL_LOGIN && <>
				<EmailLogin />
				<br />
				<div
					className="link text-center"
					onClick={e => setMode(EMAIL_SIGNUP)}
				>No account yet? Click here.</div>
				<br />
				<div
					className="link text-center"
					onClick={e => setMode(RESET_PASSWORD_REQUEST)}
				>Forgotten your password? Click here.</div>
			</>}

			{/* Requesting a new password */}
			{mode === RESET_PASSWORD_REQUEST && <>
				<ResetPasswordRequest />
				<br />
				<div
					className="link text-center"
					onClick={e => setMode(EMAIL_LOGIN)}
				>Back to login? Click here</div>
			</>}

			{/* Requesting a new password */}
			{mode === RESET_PASSWORD && <>
				<ResetPassword onRequestFormChange={onRequestFormChange} />
				<br />
				<div
					className="link text-center"
					onClick={e => setMode(EMAIL_LOGIN)}
				>Back to login? Click here</div>
			</>}

			{/* Signing up manually */}
			{mode === EMAIL_SIGNUP && <>
				<EmailSignup />
				<br />
				<div
					className="link text-center"
					onClick={e => setMode(EMAIL_LOGIN)}
				>Already have an account? Click here.</div>
			</>}
		</div>
	</div>

}

function SocialButton({ provider }) {

	// Check for affiliate codes.
	const aa = getAffiliate();

	return <a
		className={`socialButton socialButton-${provider}`}
		href={`${API_ROOT}/connect/${provider}${aa ? `?aa=${aa}` : ""}`}
	>
		<ImgIcon src={{ facebook, google }[provider]} size={25} />
		<span>Continue with {provider}</span>
	</a>
}